import React, { Component } from "react";
//import profile from '../../assets/images/avatar.png';
import { PnkHtmlForm } from '../../pnk-react/pnk-controls/pnk-html-form';
import PnkImage from '../../pnk-react/pnk-ctrl/pnk-image'


export default class UserProfilePage extends Component {
    // constructor() {
    //     super()
    // }

    EditMode = () => {
        // alert('jjj')
        if (this.props.mystate.Profilemode === 'Normal') {

            this.props.ChangeMode();
            var element = document.querySelectorAll('.show')
            element.forEach(show => {
                show.disabled = false
                show.classList.remove('form-control-profile-fixed')
                show.classList.add('form-control-profile')
            })


        }
        else {
            this.props.UpdateProfile();
            var element = document.querySelectorAll('.show')
            element.forEach(show => {
                show.disabled = true
                show.classList.remove('form-control-profile')
                show.classList.add('form-control-profile-fixed')
            })
        }

    }

    HandleDOB = (date)=>{

      //  alert(date)

        var dd = new Date(date).getDate();
        var mm = new Date(date).getMonth()+1;
        var yyyy = new Date(date).getFullYear();
        
    let finalDate = '';

    if(dd<10){
      dd = '0'+dd;
    }
    if(mm<10){
        mm='0'+mm;
    }



    finalDate = dd+'-'+mm+'-'+yyyy;

    return finalDate;


    }

    render() {
        return (
            <div className="container-fluid user-profile-main">

            {
           //     this.props.mystate.userEmail !== '' && this.props.mystate.userEmail !== null && this.props.mystate.userEmail !== undefined ?


            
                <div className="row">
                    <div className="col-12">
                        <div className="row">

                            <div className="col-9 col-md-6 col-lg-6" style={{ display: 'flex' }}>

                                <PnkHtmlForm id="frmUserEntry" onsubmit={this.props.UploadProfilePic} submitbtn="btnprofilepic">
                                    <div class="form-group userProfileImgUpload" id="kinship-img-file" >
                                        <PnkImage
                                            class="form-control form2-control-ausi"
                                            id="fileUserImage"
                                            onChange={this.props.HandleUserImage}
                                            destinationFolder="application/public/images/uploads/kinship/users"
                                            allowedTypeStr="png,jpg,jpeg,pdf"
                                            btnPreviewText="Upload Your Image"
                                            multiple="false"
                                            limitFiles="1"
                                            name="fileUserImage"
                                            id="fileUserImage"
                                            pnkvalidate="forceentry"
                                            pnkvalue={this.props.mystate.fileUserImage}
                                            value={this.props.mystate.fileUserImage}
                                            mode={this.props.mystate.mode}
                                            renderChild={this.props.mystate.renderChild}
                                            previewImageSrc={this.props.mystate.fileUserImage}
                                            pnkdisplayerrormsg="Invalid User Image"
                                            itemStyle="height:150px;text-align:center"
                                        />


                                    </div>


                                    {/*   <div className="user-profile-pic-btn">
                                                <button id="btnprofilepic" className="btn" onClick={() => this.props.UploadProfilePic()}>Update Pic</button>
                            </div>   */}
                                </PnkHtmlForm>
                                {
                                    this.props.mystate.showUpdateBtn === true ?

                                        <div className="profile-upload-btn">
                                            <p onClick={this.props.UploadProfilePic}>Update Pic</p>
                                        </div>
                                        : ''
                                }
                            </div>




                            <div className="col-3 col-md-6 col-lg-6">
                                <div className="user-profile-edit">
                                    {this.props.mystate.Profilemode === 'Update' ?
                                        <p onClick={this.EditMode}>Update</p> :
                                        <p onClick={this.EditMode}>Edit</p>
                                    }

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="user-profile-seperation">

                        </div>
                    </div>
                    <div className="col-12">
                        <div className="user-profile-content">
                            <h6>Name</h6>
                            <div class="form-group"  >
                                <input type="text" disabled="true" class="show form-control-profile-fixed" id="txtUserName" name="txtUserName" value={this.props.mystate.userName}
                                    onChange={this.props.HandleProfileInputs}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="user-profile-seperation-thin">
                        </div>
                    </div>
                    <div className="col-12">

                        <div className="user-profile-content">
                            <h6>Email address</h6>
                            <p>{this.props.mystate.userEmail}</p>
                        </div>
                       {/* <div className="user-profile-content-verify">
                            {this.props.mystate.userEmailStatus === true ?
                                <p>Verified</p>
                                :
                                <p onClick={() => this.props.ShowOtpModal('email')}>Verify your email</p>

                            }
                        </div>
                        */}
                    </div>

                    <div className="col-12">
                        <div className="user-profile-seperation-thin">
                        </div>
                    </div>
                    <div className="col-12">

                        <div className="user-profile-content">
                            <h6>Phone Number</h6>
                            {this.props.mystate.userMobile === '' || this.props.mystate.userMobile === undefined ?
                                <div class="form-group"  >
                                    <input type="text" disabled="true" class="show form-control-profile-fixed" id="txtUserMobile" name="txtUserMobile" value={this.props.mystate.userMobile}
                                        onChange={this.props.HandleProfileInputs}
                                        placeholder="Enter Mobile Number"
                                    />
                                </div>
                                :
                                <div class="form-group">
                                    <input type="text" disabled="true" class="show form-control-profile-fixed" id="txtUserMobile" name="txtUserMobile" value={this.props.mystate.userMobile}
                                        onChange={this.props.HandleProfileInputs}
                                    />
                                </div>
                            }
                        </div>
                        {/*
                        <div className="user-profile-content-verify">
                            {this.props.mystate.userMobileStatus === true ?
                                <p>Verified</p>
                                :
                                <p onClick={() => this.props.ShowOtpModal('mobile')}>Verify your Number</p>

                            }

                        
                        </div>
                        */}
                    </div>


                    <div className="col-12">
                        <div className="user-profile-seperation-thin">
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="user-profile-content">
                            <h6>Date of Birth</h6>
                            {this.props.mystate.userAge === '' || this.props.mystate.userAge === undefined ?
                                <div class="form-group"  >
                                    <input type="text" disabled="true" class="show form-control-profile-fixed" id="txtUserAge" name="txtUserAge" value={this.props.mystate.userAge}
                                        onClick={this.props.HandleProfileInputs}
                                        onChange={this.props.HandleProfileInputs}
                                        placeholder="Enter Age"
                                    />
                                </div>
                                :
                                <div class="form-group"  >
                                    <input type="text" disabled="true" class="show form-control-profile-fixed" id="txtUserAge" name="txtUserAge" value={this.HandleDOB(this.props.mystate.userAge)}
                                        onClick={this.props.HandleProfileInputs}
                                        onChange={this.props.HandleProfileInputs}
                                    />
                                </div>
                            }

                        </div>
                    </div>
                    <div className="col-12">
                        <div className="user-profile-seperation-thin">
                        </div>
                    </div>

                </div>

                    //  :''
                      }

            </div>
        )
    }

}

